interface PhoneIconSize24Props {
  className?: string;
}

const defaultProps = {
  className: undefined,
};

function PhoneIconSize24({ className }: PhoneIconSize24Props) {
  return (
    <svg
      className={className}
      fill="none"
      height="24"
      viewBox="0 0 24 24"
      width="24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16 22H8C6.9 22 6 21.1 6 20V4C6 2.9 6.9 2 8 2H16C17.1 2 18 2.9 18 4V20C18 21.1 17.1 22 16 22Z"
        fill="#FFB600"
      />
      <path
        d="M11 19H13"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="2"
      />
      <line
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
        x1="10.5"
        x2="13.5"
        y1="4.5"
        y2="4.5"
      />
    </svg>
  );
}

PhoneIconSize24.defaultProps = defaultProps;

export default PhoneIconSize24;
